export default __webpack_public_path__ + "static/media/E10.e633e4d7.jpeg";